module.exports = __webpack_public_path__ + "static/img/gold.e0b93737.png";